function isObject (value) {
  return value === Object(value)
}

function isArray (value) {
  return Array.isArray(value)
}

function isFile (value) {
  return value instanceof File
}

function makeArrayKey (key, indice) {
  if (key.length > 2 && key.lastIndexOf('[]') === key.length - 2) {
    return key
  } else {
    return key + '['+ indice +']'
  }
}

function objetoParaFormData(objeto, formData, prefixo) {
  if (!formData) {
    formData = new FormData();
  }

  Object.keys(objeto).forEach(chave => {
    if (isObject(objeto[chave]) && !isArray(objeto[chave]) && !isFile(objeto[chave])) {
      objetoParaFormData(objeto[chave], formData, chave);
    } else if (isArray(objeto[chave])) {
      objeto[chave].forEach(function (valor, indiceArray) {
        var arrayKey = makeArrayKey(chave, indiceArray)

        if (isObject(valor) && !isFile(valor)) {
          objetoParaFormData(valor, formData, arrayKey)
        } else {
          formData.append(arrayKey, valor)
        }
      })
    } else {
      if (prefixo) {
        formData.append(prefixo + '[' + chave + ']', objeto[chave]);
      } else {
        formData.append(chave, objeto[chave]);
      }
    }
  });

  return formData;
}

export default objetoParaFormData;



// WEBPACK FOOTER //
// ./FrontEnd/js/converter-objeto-formdata.js